import { DESELECT_CLIENT } from "../../CONSTANTS";

export default function deselectClient() {
  return {
    type: DESELECT_CLIENT,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/clients/deselectClient.js